<template>
  <div class="index" >
    <!-- <Header ref="header" title="自然人用户注册" :back="true" left="" /> -->
    <div class="windowmain">
      <div class="boxmain">
        <p class="boxTitle"> <span style="margin-right:12px;color:#00599c;display: flex;align-items: center;"><img style="width:18px;margin-right:2px" src="@/views/image/userregister/icon_user.png" alt="" srcset=""> 自然人注册:</span> 1/2 填写基本信息</p>
        <van-form validate-first ref="form">
          <div class="boxinput">
            <div class="filed-vertical">
              <div class="lable"><span>*</span>姓名</div>
              <van-field
                v-model="certName"
                class="input"
                :rules="checkCertName"
                clearable
                placeholder="请填写姓名"
              />
            </div>
            <div class="filed-vertical">
              <div class="lable"><span>*</span>证件类型</div>
              <van-field
                placeholder="请选择证件类型"
                v-model="orginTypeName"
                 :rules="checkType" 
                @click="selectOrginType()"
                right-icon="arrow"
                clickable
                readonly
              ></van-field>
            </div>
            <div  class="inTimes" v-if="orginType == '01' && !inTime">
                <div class="inTimes_title">
                  <van-icon name="warning" class="iconTip" /> 提示
                </div>
                <div v-if="showWz!='true'">
                  当前非居民身份证联网核查服务时段，请在服务时段（{{timeRange}}）重试。
                </div>
                <div v-if="showWz=='true'">
                  当前非居民身份证联网核查服务时段，您可在服务时段（{{timeRange}}）重试，或前往微信 / 支付宝「掌上单一窗口」小程序注册。           
                </div>
            </div>
            <div v-else>
              <div class="filed-vertical">
                <div class="lable"><span>*</span>国家/地区</div>
                <SwselectLaySearch
                  @selectObj="receiveCustomsVal"
                  ref="myCounty"
                  :rules="checkCountry" 
                  :isrequired="customsCode.required"
                  :tableName="orginType"
                  uri="/zsdyckserver/mb/user/countryListReg?iddocType="
                  :value="customsCode.name"
                  placeholder="请选择国家/地区"
                ></SwselectLaySearch>
              </div>

              <div class="filed-vertical">
                <div class="lable"><span>*</span>证件号码</div>
                <van-field
                  v-model="prsnIddocNo"
                  class="input"
                  name='idnum'
                  :rules="checkPrsnIddocNo"
                  maxlength="18"
                  clearable
                  placeholder="请输入证件号码">
                  <template #right-icon v-if="orginType=='01'">
                    <img style="width:20px;position: relative;top: 4px;" src="@/views/image/userregister/sm.png" alt="" @click="sm">
                  </template>
                </van-field>
              </div>
              <div class="filed-vertical" v-if="orginTypeShow">
                <div class="lable"><span v-if="dateRequired">*</span>身份证起始日期</div>
                <swSelectDate
                  label="开始时间"
                  id="startDate"
                  @change="dataChange"
                  :rules="checkStarDate" 
                  placeholder="请选择开始日期"
                  v-model="startDate"
                  format="yyyy-MM-dd"
                />
              </div>
              <div class="filed-vertical vertical3" v-if="orginTypeShow">
                <div class="lable"><span v-if="dateRequired">*</span>身份证结束日期</div>
                <swSelectDate
                  label="结束时间"
                  id="endDate"
                  @change="dataChange"
                  :rules="checkEndDate" 
                  :disabled="endDate=='长期有效'"
                  placeholder="请选择结束日期"
                  v-model="endDate"
                  format="yyyy-MM-dd"
                />

                <div class="selectRadio">
                  <van-radio-group v-model="innerValue">
                    <van-cell-group  :border="false">
                      <van-cell
                        v-for="item in options"
                        :key="item.value"
                        :title="item.label"
                        clickable
                        :border="false"
                        @click="clickMethod(item.value)"
                      >
                        <template #icon>
                          <van-radio @click.stop :name="item.value" :model-value="selected == item.value" />
                        </template>
                      </van-cell>
                    </van-cell-group>
                  </van-radio-group>
                </div>
              </div>

              <div class="filed-vertical" v-if="isShowTel">
                <div class="lable"><span>*</span>手机号码</div>
                <van-field
                  v-model="prsnMobnum"
                  class="input phone"
                  :rules="checkPhoneNum" 
                  clearable
                  placeholder="请输入手机号码"
                />
                  <!-- <template #prefix>
                    +86
                  </template>
                </van-field> -->
              </div>
              <div class="filed-vertical telInput3" v-if="isShowTel">
                <div class="lable"><span>*</span>图形验证码</div>
                <div class="verificationBox" style="position: relative">
                  <van-field
                    v-model="checkCode1"
                    id="verifital_input"
                    class="input"
                    :rules="checkPhoneimgNum" 
                    clearable
                    maxlength="4"
                    placeholder="请输入验证码"
                  ></van-field>

                  <div
                    @click="verificationCode"
                    id="verificationCode"
                    class="verificationCode"
                  >
                    <div class="codeImg">
                      <img id="code_img" :src="base64img1" />
                    </div>
                  </div>
                </div>
              </div>
              <div class="filed-vertical telInput3" v-if="isShowTel">
                <div class="lable"><span>*</span>短信验证码</div>
                <div class="verificationBox" style="position: relative">
                  <van-field
                    v-model="phoneYzm"
                    center
                    clearable
                    :rules="checkPhoneYzm" 
                    maxlength="6"
                    placeholder="请输入验证码"
                  >
                  </van-field>
                  <div id="CodeNuber" class="CodeNuber">
                    <van-button
                      size="small"
                      type="info"
                      :disabled="disabled1"
                      @click="getCode(1)"
                      >{{ CodeNuberName1 }}
                    </van-button>
                  </div>
                </div>
              </div>
              <div class="filed-vertical" v-if="!isShowTel">
                <div class="lable"><span>*</span>邮箱验证</div>
                <van-field
                  name="validator"
                  :rules="checkEmailNum"
                  class="emalil"
                  clearable
                  v-model="email"
                  placeholder="请输入邮箱验证"
                ></van-field>
              </div>
              <div class="filed-vertical telInput3" v-if="!isShowTel">
                <div class="lable"><span>*</span>图形验证码</div>
                <div class="verificationBox" style="position: relative">
                  <van-field
                    v-model="checkCode2"
                    id="verifital_input"
                    :rules="checkEmailimgNum" 
                    class="input"
                    maxlength="4"
                    clearable
                    placeholder="请输入验证码"
                  ></van-field>

                  <div
                    @click="verificationCode"
                    id="verificationCode"
                    class="verificationCode"
                  >
                    <div class="codeImg">
                      <img id="code_img" :src="base64img2" />
                    </div>
                  </div>
                </div>
              </div>
              <div class="filed-vertical telInput3" v-if="!isShowTel">
                <div class="lable"><span>*</span>邮箱验证码</div>
                <div class="verificationBox" style="position: relative">
                  <van-field
                    v-model="emailYzm"
                    center
                    clearable
                    :rules="checkEmailYzm" 
                    maxlength="6"
                    placeholder="请输入验证码"
                  >
                  </van-field>
                  <div id="CodeNuber" class="CodeNuber">
                    <van-button
                      size="small"
                      type="info"
                      :disabled="disabled2"
                      @click="getCode(2)"
                      >{{ CodeNuberName2 }}
                    </van-button>
                  </div>
                </div>
              </div>
              <div class="filed-vertical verticalTel" v-if="orginTypeShow1">
                <p v-if="isShowTel" @click="changeTel">
                  如无中国大陆境内手机号，可<span>点此进行邮箱验证</span>
                </p>
                <p v-else @click="changeTel2">
                  <span>点击填写</span>中国大陆境内手机号
                </p>
              </div>
          </div>
          </div>
        </van-form>
      </div>

      <div style="margin: 16px"  v-if="!(orginType == '01' && !inTime)">
        <van-button
          type="primary"
          style="width:100%;height:1.07rem;font-size: 0.426667rem"
          size="small"
          @click="fromSubmit()"
          >下一步</van-button
        >
      </div>
      <!-- 证件类型 -->
      <van-popup
        v-model="showOrginType"
        round
        position="bottom"
        get-container="#popup"
      >
        <van-picker
          show-toolbar
          :columns="orginTypeArray"
          @confirm="confirmOrginType"
          @cancel="cancelOrginType"
        ></van-picker>
      </van-popup>
    </div>
  </div>
</template>

<script>
import Header from "@/components/Header";
import swSelectDate from "@/views/components/swSelectDate";
import SwselectLaySearch from "@/views/components/SwselectLaySearch";
import {
  Form,
  RadioGroup,
  Radio,
  Cell,
  CellGroup,
  Field,
  Col,
  Icon,
  Row,
  Button,
  Picker,
  Popup,
  Toast,
  DatetimePicker,
  Checkbox,
  CheckboxGroup,
  NoticeBar,
  Dialog
} from "vant";
// 获取图形验证码
const getVerificationCode = function () {
  this.$http
    .get("/zsdyckserver/mb/user/captcha ")
    .then((res) => {
      if (this.isShowTel) {
        this.pacClientId1 = res.data.captchaKey;
        this.base64img1 = res.data.img;
        this.checkCode1 = "";
      } else {
        this.pacClientId2 = res.data.captchaKey;
        this.base64img2 = res.data.img;
        this.checkCode2 = "";
        
      }

    })
    .catch((err) => {
      console.warn(err);
       this.$toast("查询失败，请稍后重试");
      // this.GM.BiHint("查询失败，请稍后重试");
    });
};
// 获取证件类型
const getiddoctype = function () {
  var _this = this;
  this.$http
    .get("/zsdyckserver/mb/user/cardTypeList", {
      unLoading: true,
    })
    .then((res) => {
      console.log(res);
      // if (res.code == "0") {
        let dataList = res;
      console.log(dataList);
      for(let i =0;i<dataList.length;i++){
        _this.orginTypeArray.push(dataList[i].desc);
         _this.orginTypeData.push({ codeName: dataList[i].desc, codeValue: dataList[i].type });
      }
        console.log(this.orginTypeData,'时代大厦');
      // } 
    })
    .catch(() => {
      this.$toast("查询失败，请稍后重试");
      // this.GM.BiHint('查询失败，请稍后重试');
    });
};
//触发证件类型弹出
const selectOrginType = function () {
  this.showOrginType = true;
};
//证件类型取消事件
const cancelOrginType = function () {
  this.showOrginType = false;
};
//证件类型确认事件
const confirmOrginType = function (value) {
  this.orginTypeName = value;
  for (let i = 0; i < this.orginTypeData.length; i++) {
    const temp = this.orginTypeData[i];
    if (temp.codeName === value) {
      this.orginType = temp.codeValue;
      if (this.orginType == "01") {
        this.orginTypeShow = true;
      } else {
        this.orginTypeShow = false;
      }
      if (this.orginType == "06" || this.orginType == "08") {
        this.orginTypeShow1 = true;
        this.isShowTel = true;
      } else {
        this.orginTypeShow1 = false;
        this.isShowTel = true;
      }
         this.customsCode.value = '';
      this.customsCode.name = '';
      console.log(this.orginType, 111111);
      // this.$refs.myCounty.getparam();
      
      break;
    }
  }
  this.showOrginType = false;
};

export default {
  name: "swuserregister",
    computed: {
       checkPhoneNum() {
          if (this.isShowTel) {
              return [        
                  {
                    required: true,
                    message: "请输入11位手机号",
                    trigger: "onBlur",
                  },
                  {
                    validator: (value) => {
                      var pattern = /^1\d{10}$/
                      return pattern.test(value);
                    },
                    message: "请输入正确的手机号",  
                    trigger: "onBlur",
                  },
                ];
            }
          return []; // 不必填
       },
       checkPhoneimgNum(){
        if (this.isShowTel) {
              return [        
                  {
                    required: true,
                    message: "请输入图形验证码",
                    trigger: "onBlur",
                  },
                  {
                    validator: (value) => {
                      var pattern = /^[0-9a-zA-Z]{4}$/;
                      return pattern.test(value);
                    },
                    message: "请使用4位英文和字母组合",
                    trigger: "onBlur",
                  },
                ];
            }
          return []; // 不必填
       },
       checkPhoneYzm(){
        if (this.isShowTel) {
              return [        
                  {
                    required: true,
                    message: "请输入短信验证码",
                    trigger: "onBlur",
                  },
                  {
                    validator: (value) => {
                      var pattern = /^[0-9]{6}$/;
                      return pattern.test(value);
                    },
                    message: "请使用6位纯数字的验证码",
                    trigger: "onBlur",
                  },
                ];
            }
          return []; // 不必填
       },
       checkEmailNum() {
          if (!this.isShowTel) {
              return [        
                  {
                    required: true,
                    message: "请输入邮箱",
                    trigger: "onBlur",
                  }
                  // {
                  //   validator: (value) => {
                  //     var pattern = /^[A-Za-z0-9\u4e00-\u9fa5_]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/;
                  //     return pattern.test(value);
                  //   },
                  //   message: "邮箱格式为xxxx@xxxx.xx",
                  //   trigger: "onBlur",
                  // },
                ];
            }
          return []; // 不必填
       },
       checkEmailimgNum(){
        if (!this.isShowTel) {
              return [        
                  {
                    required: true,
                    message: "请输入图形验证码",
                    trigger: "onBlur",
                  },
                  {
                    validator: (value) => {
                      var pattern = /^[0-9a-zA-Z]{4}$/;
                      return pattern.test(value);
                    },
                    message: "请使用4位英文和字母组合",
                    trigger: "onBlur",
                  },
                ];
            }
          return []; // 不必填
       },
       checkEmailYzm(){
        if (!this.isShowTel) {
              return [        
                  {
                    required: true,
                    message: "请输入邮箱验证码",
                    trigger: "onBlur",
                  },
                  {
                    validator: (value) => {
                      var pattern = /^[0-9]{6}$/;
                      return pattern.test(value);
                    },
                    message: "请使用6位纯数字的验证码",
                    trigger: "onBlur",
                  },
                ];
            }
          return []; // 不必填
       },
       checkStarDate() {
          if (this.orginType=='01' && this.dateRequired) {
              return [{required: true,
                message: "请选择身份证起始日期",
                trigger: "onChange",
              },];
            }
          return []; // 不必填
       },
       checkEndDate() {
          if (this.orginType=='01' && this.dateRequired) {
              return [{required: true,
                message: "请选择身份证结束日期",
                trigger: "onChange",
              },];
            }
          return []; // 不必填
        },
        checkPrsnIddocNo(){
          if (this.orginType=='01') {
              return[        
                  {
                    required: true,
                    message: "请输入证件号码",
                    // trigger: "onBlur",
                  },
                  {
                    validator: (value) => {
                      var pattern = /(^\d{18}$)|(^\d{17}(\d|X|x)$)/;
                      return pattern.test(value);
                    },
                    message: "输入的证件号码不符合身份证号编码规范，请输入正确的身份证号码",
                    trigger: "onBlur",
                  },
                ];
            }
              return [        
                {
                  required: true,
                              message: "请输入证件号码",
                              trigger: "onBlur",
                            },
                                          {
                      validator: (value) => {
                        var pattern = /^[0-9A-Z]{1,18}$/;
                        return pattern.test(value);
                      },
                      message: "仅支持数字和大写字母，最长18位",
                      trigger: "onBlur",
                    },
                        ];
         },
    // 同步 innerValue 到 selected，但允许为空
    innerValue: {
      get() {
        return this.selected;
      },
      set(val) {
        // 这里 val 是 radio-group 传来的值
        // 如果当前已选中，再次点击同一个值，van-radio-group 会触发 set
        // 但我们希望实现“点击取消”，所以不能直接赋值
        // 而是通过 click 控制，这里只做同步
      }
    }
  },
    watch:{
      orginType(newval){

        this.$refs.form.resetValidation('idnum')
        if (newval=='01') {
          this.intSwitchs()
        }
      }
  },
  data() {
    return {
      certName: "",
      certNo: "",
      ieFlag: "",
      orginType: "01",
      startDate: "",
      endDate: "",
      orginTypeName: "居民身份证",
      isShowTel: true,
      orginTypeShow: true,
      email: "",
      orginTypeShow1: false,
      prsnIddocNo: "",
      showOrginType: false,
      acceptNotification: "",
      CodeNuberName1: "获取验证码",
      CodeNuberName2: "获取验证码",
      checkCode1: "",
      checkCode2: "",
      base64img1: "",
      base64img2: "",
      disabled1: false,
      disabled2: false,
      phoneYzm: "",
      emailYzm: "",
      pacClientId: "",
      selected: '0',
      checkMail: true,
      prsnMobnum: "",
      orginTypeArray: [],
      orginTypeData: [],
      customsCode: {
        label: "",
        placeholder: "",
        maxlength: "50",
        required: true,
        readonly: false,
        value: "",
        name: "",
      },
      statusBar: 0,
      value: "",
       options: [
        { label: '5年', value: '5' },
        { label: '10年', value: '10' },
        { label: '20年', value: '20' },
        { label: '长期有效', value: '00000000' },
      ],
      checkType:[
        {
          required: true,
          message: "请选择证件类型",
          trigger: "onChange",
        },
      ],
      checkCountry:[
        {
          required: true,
          message: "请选择国家/地区",
          trigger: "onChange",
        },
      ],
      checkCertName:[        
        {
          required: true,
          message: "请输入姓名",
          trigger: "onBlur",
        },
        {
          validator: (value) => {
             var pattern = /[!#$%^*{}\\[\]:<>?？|~]/im;
            return !pattern.test(value);
          },
          message: "姓名不能含有 !#$%^*{}[]:<>?|~ 字符",
          trigger: "onBlur",
        },
       ],
       dateRequired:true,
       inTime:true,
       timeRange:'',
       showWz:''
    };
  },
  activated() {
    this.$refs.myCounty.show = false; // 进入页面时强制关闭弹窗
  },
  mounted() {
    this.statusBar = this.$tool.statusBar(44);
    this.getiddoctype();
    this.getVerificationCode();
    this.intType()
  },

  beforeRouteLeave(to, from, next) {
    if (to.path == '/swuserregisterIndex') {
        let that = this
        Dialog.confirm({
          message: "操作未完成，是否退出？",
          theme: "round-button",
        }).then(() => {
          next()
        })
        .catch(() => {
          next(false) 
          Dialog.close();
        });
  }else{
    next()
  }
  },
  methods: {
    // 获取功能控制开关，确定界面引导流程
    intType(){
            this.$http.get('/nuserwebserver/param/register/switchs').then((res) => {
                if (res.success) {
                  this.inTime = res.data.prsnIddoc01ValidIntMpsTimewindow
                  this.showWz =  JSON.parse(res.data.prsnIddoc01RegMiniProgramQrcode).show_qrcode
                  this.timeRange = res.data.prsnIddoc01ValidIntMpsTimewindowRange
                  if (this.inTime) {
                    this.orginType = '01'
                    this.orginTypeName = '居民身份证'
                    this.orginTypeShow = true;
                    this.dateRequired = res.data.prsnIddoc01ValidIntZwaEnable
                  }else{
                    this.orginType = '08'
                    this.orginTypeName = '港澳居民来往内地通行证'
                    this.orginTypeShow = false;
                  }
                }else{
                  this.$toast(res.msg)
                }
              })
              .catch(() => {
                this.$toast("查询失败");
              });
    },
    intSwitchs(){
      this.$http.get('/nuserwebserver/param/register/switchs').then((res) => {
                if (res.success) {
                  this.inTime = res.data.prsnIddoc01ValidIntMpsTimewindow
                  this.showWz =  JSON.parse(res.data.prsnIddoc01RegMiniProgramQrcode).show_qrcode
                  this.timeRange = res.data.prsnIddoc01ValidIntMpsTimewindowRange
                  if (this.inTime) {
                    this.dateRequired = res.data.prsnIddoc01ValidIntZwaEnable
                  }
                }else{
                  this.$toast(res.msg)
                }
              })
              .catch(() => {
                this.$toast("查询失败");
              });
    },
    dataChange(){
       this.selected = '0';
    },
      ocrIdCard() {
        var systemType = this.getSystemType()
        var p = new Promise((res) => {
            window.ocrIdCardResult = function(val) {
                res(val)
            }
        })
        switch (systemType) {
            case '1':
                window.webkit.messageHandlers.ocrIdCard.postMessage('');
                break
            case '2':
                javascript: android.ocrIdCard();
                break
        }
        return p
    },
    getSystemType() {
        var u = navigator.userAgent
        var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)
        var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1
        if (isiOS) {
            return '1'
        } else if (isAndroid) {
            return '2'
        } else {
            return '3'
        }
    },
    sm(){
        this.ocrIdCard().then((data) => {
          var dataJson = JSON.parse(data);
          this.certName = dataJson.name
          this.prsnIddocNo = dataJson.idNumber
          this.startDate = dataJson.validFrom;
          this.endDate = dataJson.validTo.replace("长期","长期有效")
          // $("#prsnName").val(dataJson.name);
          // $("#prsnIddocNo").val(dataJson.idNumber);
          // $("#effDate").val(dataJson.validFrom.replace("-","").replace("-",""));
          // $("#expDate").val(dataJson.validTo.replace("-","").replace("-","").replace("长期","00000000"));
      });
    },
    selectOrginType,
    confirmOrginType,
    cancelOrginType,
    getiddoctype,
    getVerificationCode,
    fromSubmit() {
      let url = '';
      let t={
        name:this.certName,
        idDocType:this.orginType,
        idDocNo:this.prsnIddocNo,
        country:this.customsCode.value,
        origin:'5',
      }
      if (this.orginType == '01') {
          t = {
              ...t,
              "effDate": this.startDate.replace(new RegExp('-',"g"),''),
              "expDate": this.endDate == "长期有效"?'00000000':this.endDate.replace(new RegExp('-',"g"),''),
          }
      }
      if (this.isShowTel) {
         t = {
              ...t,
              "mobile":this.prsnMobnum,
              "verifyCode":this.phoneYzm,
          }
          url = '/zsdyckserver/mb/user/registerByMobile'
      }else{
          t = {
              ...t,
              "email":this.email,
              "verifyCode":this.emailYzm,
          }
           url = '/zsdyckserver/mb/user/registerByEmail'
      }
         this.$refs.form.validate().then(() => {
            this.$http.post(url, t).then((res) => {
                if (res.success) {
                  this.$router.push({
                    path: "/swuserregpsd",
                    query:{
                      verifyKey:res.data,
                      registerType:this.isShowTel?'mobile':'email'
                    }
                  });
                }else{
                  this.$toast(res.msg)
                }
              })
              .catch(() => {
                this.$toast("查询失败");
              });
          })

    },
    receiveCustomsVal(val) {
      this.customsCode.value = val.code;
      this.customsCode.name = val.country;
    },
    emailvalidator(val) {
      if (val !== "") {
        var reg =
          /^[a-zA-Z0-9]+([-_.][a-zA-Z0-9]+)*@[a-zA-Z0-9]+([-_.][a-zA-Z0-9]+)*\.[a-z]{2,}$/;
        console.log("this.checkMail = false;");
        console.log(reg.test(val));
        if (!reg.test(val)) {
          return false;
        } else {
          return true;
        }
        return reg.test(val);
      }
      return true;
    },
    verificationCode: function () {
      //  重新点击验证码
      this.getVerificationCode();
    },
    addYears(dateString, years) {
      if (!dateString) return '';
      const date = new Date(dateString);
      const newDate = new Date(date);
      newDate.setFullYear(date.getFullYear() + years);
      return newDate.toISOString().split('T')[0];
    },
    clickMethod(value) {
      if (this.selected!='') {
        if (this.startDate=='') {
          this.$toast('请选择开始日期')
          return
        }
      }
      this.selected = this.selected == value ? '' : value;
      switch (this.selected) {
        case '00000000':
          this.endDate = "长期有效";
          break;
        case '5':
          this.endDate = this.addYears(this.startDate,5);
          break;
        case '10':
          this.endDate = this.addYears(this.startDate,10);
          break;
        case '20':
          this.endDate = this.addYears(this.startDate,20);
          break;
      
        default:
          this.endDate = "";
          break;
      }
    },
    // 点击切换邮箱 手机
    changeTel: function () {
      this.isShowTel = false;
      this.getVerificationCode()
    },
    changeTel2: function () {
      this.isShowTel = true;
      this.getVerificationCode()
    },
    //获取手机/邮箱验证码
    getCode: function (val) {
      if (val == 1) {
          if (this.prsnMobnum.trim().length == 0) {
            this.$toast("请先填写手机号");
            return;
          }
          if (this.checkCode1.trim().length == 0) {
            this.$toast("请先填写图片验证码");
            return;
          }
          let params = {
            captchaKey: this.pacClientId1,
            captchaValue: this.checkCode1,
            mobile:this.prsnMobnum,
            origin:'5'
          };

          this.disabled1 = true;
          this.$http
          .post("/zsdyckserver/mb/user/sendMobile", params)
          .then((res) => {
            if (res.code == "0") {
              this.$toast("验证码发送成功");
              let that = this;
              let time = 60;
              let timer = setInterval(function () {
                if (time == 0) {
                  clearInterval(timer);
                  that.disabled1 = false;
                  that.CodeNuberName1 = "重新获取";
                } else {
                  that.disabled1 = true;
                  that.CodeNuberName1 = time + "秒";
                  time--;
                }
              }, 1000);
            } else {
              this.disabled1 = false;
              this.$toast(res.msg);
            }
          })
          .catch(() => {
            this.$toast("查询失败");
          });
      } else if (val == 2) {
          if (this.email.trim().length == 0) {
            this.$toast("请先填写邮箱");
            return;
          }
          if (this.checkCode2.trim().length == 0) {
            this.$toast("请先填写图片验证码");
            return;
          }
          let params = {
            captchaKey: this.pacClientId2,
            captchaValue: this.checkCode2,
            email: this.email,
            origin:'5'
          };
          console.log( this.email,params,'哈哈哈哈');

          this.disabled2 = true;
          this.$http
          .post("/zsdyckserver/mb/user/sendEmail", params)
          .then((res) => {
            if (res.code == "0") {
              this.$toast("验证码发送成功");
              let that = this;
              let time = 60;
              let timer = setInterval(function () {
                if (time == 0) {
                  clearInterval(timer);
                  that.disabled2 = false;
                  that.CodeNuberName2 = "重新获取";
                } else {
                  that.disabled2 = true;
                  that.CodeNuberName2 = time + "秒";
                  time--;
                }
              }, 1000);
            } else {
              this.disabled2 = false;
              this.$toast(res.msg);
            }
          })
          .catch(() => {
            this.$toast("查询失败");
          });
      }
    },
  },

  components: {
    Header,
    swSelectDate,
    SwselectLaySearch,
    [Field.name]: Field,
    [Button.name]: Button,
    [Form.name]: Form,
    [RadioGroup.name]: RadioGroup,
    [Radio.name]: Radio,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Field.name]: Field,
    [Col.name]: Col,
    [Row.name]: Row,
    [Icon.name]: Icon,
    [Button.name]: Button,
    [Picker.name]: Picker,
    [Popup.name]: Popup,
    [Toast.name]: Toast,
    [DatetimePicker.name]: DatetimePicker,
    [NoticeBar.name]: NoticeBar,
    [Dialog.Component.name]: Dialog.Component,
    [Checkbox.name]: Checkbox,
    [CheckboxGroup.name]: CheckboxGroup,
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/css/public.scss";
@import "@/views/css/userindex.scss";
// ::v-deep .van-cell {
//   display: block;
// }
// ::v-deep .van-cell::after {
//   border-bottom: 0px;
// }
 ::v-deep  .phone .van-field__body {
        padding: 4px 9px 4px 30px !important;
        position: relative;
      }

       ::v-deep .phone .van-field__body::before{
          position: absolute;
          content: "+86";
          left: 4px;
          top: 4px;
          font-size: 14px;
          display: block;
          color: #333;
      }
.windowmain {
  width: 100%;
  overflow-x: hidden;
  background: #fff;
  .boxTitle {
    font-size: 16px;
    width: 100%;
    background: #f7f8fa;
    color: #333;
    font-weight: bold;
    display: flex;
    align-items: center;
   padding: 12px 0px 10px 20px;
  }
  .boxmain {
    width: 100%;
  }
  .boxinput {
    // margin: 0px 15px 0px 15px;
    height: auto;
    border-radius: 4px;
    background: #fff;
    padding: 10px 20px;
    .filed-vertical {
      display: flex;
      flex-direction: column;
      align-items: stretch;
      margin-bottom: 8px;
      .lable {
        font-size: 12px;
        color: #333;
      }
      .lable span {
        display: inline-block;
        color: #ee0a24;
        margin-right: 4px;
      }
      ::v-deep.van-cell {
        padding: 0px;
      }
      ::v-deep .van-cell .van-field__body {
        border: 1px solid #ddd;
        padding: 4px 9px;
        border-radius: 4px;
        margin-top: 6px;
      }

//       .van-field__prefix {
//   margin-right: 8px;
//   color: #969799;
//   font-size: 14px;
//   user-select: none;
// }
      ::v-deep .van-cell .van-field__body:hover {
        border: 1px solid #00599c;
        box-shadow: 0px 2px 5px 3px raga(0, 89, 156, 0.1);
      }
      .selectRadio {
        margin-top: 5px;
        width: 100%;
        .van-cell-group {
          display: flex;
          width: auto;
          float: right;
          .van-cell{
             display: flex;
             align-items: center;
             white-space: nowrap;
             width: auto;
            margin-left: 10px;
          }
          .van-radio{
            margin-right: 4px;
          }
        }
      }
      // ::v-deep .van-field__control:focus{
      //   border: 1px solid #00599c;
      //   box-shadow:  0px 2px 5px 3px raga(0,89,156,0.10);
      // }
    }
    .vertical3 {
      margin-bottom: 0px;
    }
  }

  .ftBton {
    padding: 0px 15px;
    font-size: 11px;
    color: #999;
  }
  .verticalTel {
    text-align: right;
    font-size: 14px;
    color: #666;
    span {
      color: #096ac6;
      text-decoration: underline;
    }
  }
  .telInput3 .van-cell {
    width: 70%;
  }
  .verificationCode {
    top: 7px;
    right: 0px;
  }
  .verificationCode .codeImg {
    width: 88px;
    height: 32px;
  }
  .CodeNuber {
    position: absolute;
    right: 0;
    width: 2.4rem;
    height: 0.933333rem;
    top: 7px;
  }
  .van-button--small {
    width: 87px;
    padding: 0px;
    background: #00599c;
    border: 1px solid #00599c;
  }
  // ::v-deep .van-checkbox__icon {
  //   height: 0.9rem;
  // }
  ::v-deep #endDate .van-field--disabled .van-field__body {
    background: #efefef;
    border: 1px solid #ddd;
  }
  ::v-deep .van-radio__label {
    margin-left: 4px;
  }
  ::v-deep .van-checkbox__icon .van-icon {
    font-size: 11px;
  }
  ::v-deep .van-checkbox__label {
    color: #999;
    span {
      color: #096ac6;
    }
  }
  .inTimes{
    margin: 30px -10px 0;
    background: #fff9e2;
    color: #917545;
    padding: 6px 8px 12px;
    line-height: 1.5;
    .iconTip{
      color: #917545;
    }
    .inTimes_title{
      text-align: center;
      font-weight: bold;
      margin-bottom: 8px;
      font-size: 13px;
    }
  }
}
</style>